export default __webpack_public_path__ + "static/media/qr-code-3.72f5fba9.svg";